module.exports = __webpack_public_path__ + "media/images/honey/two_litter-a6b99b502f93db0097b5140bcb2e647b.png";